import { createFileRoute } from '@tanstack/react-router'

import { LearnpathsCreatorBasicInfo } from '@/learnpaths-creator/components/LearnpathsCreatorBasicInfo/LearnpathsCreatorBasicInfo'

export const Route = createFileRoute(
  '/company/learnpaths/add/general-information/$learnpathId',
)({
  component: LearnpathsCreatorBasicInfo,
})
